/**
 * AutoMapa global SEO defaults (Milestone 14).
 */
import { SEO_SITE_NAME } from "../constants/seoPageConstants";

export const AUTOMAPA_SITE_NAME = SEO_SITE_NAME;

export const AUTOMAPA_DEFAULT_TITLE = "AutoMapa | Carros usados en Colombia";

export const AUTOMAPA_DEFAULT_DESCRIPTION =
  "Busca, compara y revisa carros usados en Colombia con señales de precio, riesgo, concesionarios y checklist de compra.";

/** Verified public asset — do not reference missing paths. */
export const AUTOMAPA_DEFAULT_OG_IMAGE = "/icons/icon-512.svg";

export const AUTOMAPA_LOGO_URL = "/icons/icon-512.svg";

export const AUTOMAPA_LOCALE = "es_CO";

export const AUTOMAPA_OG_TYPE = "website";

export const AUTOMAPA_PRODUCT_OG_TYPE = "product";

export const PUBLIC_SEARCH_PATH = "/comprar/carros-usados";

export const PUBLIC_CHECKLIST_PATH = "/checklist-compra";

export const PUBLIC_SELL_YOUR_CAR_PATH = "/vender-mi-carro";

/** Runtime dealer directory index (AutoMapa public). */
export const PUBLIC_DEALER_DIRECTORY_PATH = "/v/automap/concesionarios";

/** Legacy path — redirects to {@link PUBLIC_DEALER_DIRECTORY_PATH}. City SEO slugs may remain here. */
export const LEGACY_DEALER_DIRECTORY_PATH = "/concesionarios";

export const PUBLIC_VEHICLE_DETAIL_PREFIX = "/carros";

export const PUBLIC_DEALER_DETAIL_PREFIX = "/v/automap/concesionarios";

export const RUNTIME_VEHICLE_SEARCH_PATH = "/v/automap/vehicles";

export const TITLE_MAX_LENGTH = 65;

export const DESCRIPTION_MAX_LENGTH = 170;

/** Params stripped from canonical URLs. */
export const CANONICAL_STRIP_PARAMS = new Set([
  "sort",
  "page",
  "pageSize",
  "view",
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_term",
  "utm_content",
  "fbclid",
  "gclid",
  "ref",
]);
